import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DataObject } from '@shared/models/data-object.model';
import { fromEvent, filter, map, switchMap, EMPTY } from 'rxjs';
import { TrackActionIdentifierDictionary } from './track-user-actions.component.model';
import { TrackUserActionService } from './track-user-actions.service';

@UntilDestroy()
@Component({
  selector: 'miq-track-actions',
  template: '',
  standalone: false,
})
export class MiqTrackUserActionsComponent implements OnInit {
  @Input() scope: string;
  @Input() context: DataObject;

  constructor(private trackUserActionServ: TrackUserActionService) {}

  #filterClickEvent = ({ target }) =>
    target?.dataset?.trackActionIdentifier &&
    target?.dataset?.trackActionScope &&
    this.scope === target?.dataset?.trackActionScope;

  ngOnInit() {
    fromEvent(document, 'click')
      .pipe(
        untilDestroyed(this),
        filter(this.#filterClickEvent),
        map(({ target }) => ({
          trackActionIdentifier: target.dataset.trackActionIdentifier,
          trackActionScope: target.dataset.trackActionScope,
        })),
        switchMap(({ trackActionScope, trackActionIdentifier }) => {
          const payload = TrackActionIdentifierDictionary[trackActionScope]?.[trackActionIdentifier]?.(this.context);
          return payload ? this.trackUserActionServ.registerAction(payload) : EMPTY;
        })
      )
      .subscribe();
  }
}
